import { utils } from "pixi.js";
import gsap from "gsap";
import { PixiPlugin } from "gsap/PixiPlugin";
import { settings } from "../settings";
import { pixiApp } from "./initializePixi";
import { gameAssets, setAmazingWinValueBitmap } from "./gameUI";


gsap.registerPlugin(PixiPlugin);


export async function resolveAndKillTweens(targets) {
  const tweens = gsap.getTweensOf(targets);
  for (const tween of tweens) {
    if ((tween)['_prom']) (tween)['_prom']();
  }
  gsap.killTweensOf(targets);
}

export const viewAppear = {
  view : () => {
    gameAssets.gameScreen.viewAppear = () => {
        pixiApp.app.renderer.view.style.width = `${gameAssets.gameScreen.windowWidth}px`
        pixiApp.app.renderer.view.style.height = `${gameAssets.gameScreen.windowHeight}px`
        window.scrollTo(0, 0)
      
        pixiApp.app.renderer.resize(settings.currentWidth, settings.currentHeight)
    }  
  }
}

export function pixiView(){
  pixiApp.app.renderer.view.style.width = `${settings.windowWidth}px`;
  pixiApp.app.renderer.view.style.height = `${settings.windowHeight}px`;
  window.scrollTo(0, 0);
}

export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const sceneTransition = async(gameObject, duration, cb = ()=>{}) => {
    resolveAndKillTweens(gameObject)
    const tl = gsap.timeline()
    await tl.to(gameObject, {
      alpha: 0,
      duration,
      ease: 'sine.in',
      onComplete: cb
    })
    .to(gameObject, {
      alpha: 1,
      duration,
      ease: 'sine.in'
    })
}

export const tweenFade = async(gameObject, isVisible, duration = 0.2, cb = ()=>{}) => {
  gameObject.visible = true
  resolveAndKillTweens(gameObject)
  const tl = gsap.timeline()
  await tl.to(gameObject, {
    alpha: isVisible ? 1 : 0,
    duration,
    ease: 'sine.in',
    onComplete: cb
  })
}


export async function tweenFadeAppear (gameObject, isVisible, timeDuration = 0.2, cb = ()=> {}) {
  if(!gameObject) return
  if (!gameObject?.initialX) gameObject.initialX = gameObject.x
  if (!gameObject?.finalY) gameObject.finalY = gameObject.y
  if (!gameObject?.finalX) gameObject.finalX = gameObject.x
  if (!gameObject?.finalY) gameObject.finalY = gameObject.y
  
  const xPos = isVisible ? gameObject.finalX : gameObject.initialX
  const yPos = isVisible ? gameObject.finalY : gameObject.initialY
  const duration = timeDuration

  if(isVisible) {
      gameObject.visible = true
      gameObject.alpha = isVisible ? 0 : 1
  }

  resolveAndKillTweens(gameObject)
  const tl = gsap.timeline()
  await tl.to(gameObject, {
  x: xPos,
  y: yPos,
  alpha: isVisible ? 1 : 0,
  duration,
  ease: 'sine.in',
  onComplete: () => {
    gameObject.visible = isVisible
    cb()
    return
    }
  })
}

export const tweenScaleAppear = async(gameObject, duration = 0.2, callbackFunction = () => {}) => {
  resolveAndKillTweens(gameObject)
  const tl = gsap.timeline()
  await tl.to(gameObject, {
    pixi: {
      scale: 2
    },
    duration: duration * 0.5,
    ease: 'power1.in'
  })
  .to(gameObject, {
    pixi: {
      scale: 1
    },
    duration: duration * 0.5,
    ease: 'power1.out',
    onComplete: () => {
      callbackFunction()
      return
      }
    })
}

export const tweenScaleDisAppear = async(gameObject, duration = 0.2, callbackFunction = () => {}) => {
  resolveAndKillTweens(gameObject)
  const tl = gsap.timeline()
  await tl.to(gameObject, {
    pixi: {
      scale: 0
    },
  duration,
  ease: 'power2',
  onComplete: () => {
    callbackFunction()
    return
    }
  })
}

export const incrementValue = async(gameObject, value, duration) => {
    const tl = gsap.timeline()
  
    tl.to(gameObject, {
      duration: duration - 4,
      repeat: 1,
      repeatDelay: Infinity,
      ease:"expo.out",
      onUpdate: function () {
        const amount = (Math.floor(this.progress() * value * 100) / 100).toFixed(2)
        gameObject.text = amount
      },
      onComplete: function () {
        tl.kill()
      }
    })
}


export const scaleFactorScaleToFit = (elementWidth, elementHeight) => {
  let scale = 1
  scale = settings.currentWidth < settings.currentHeight ? 
            settings.currentHeight / elementHeight : 
            settings.currentHeight / elementHeight

  return scale
}

export const scaleFactorScaleStretch = (elementWidth, elementHeight) => {
  let scale = 1
  if(utils.isMobile.any){
    scale = settings.currentWidth < settings.currentHeight ? 
      settings.currentHeight / elementHeight :
      settings.currentWidth / elementWidth 
  }else{
    scale = settings.currentWidth < settings.currentHeight ? 
      settings.currentWidth / elementWidth : 
      settings.currentHeight / elementHeight
  }
  if(elementWidth < elementHeight) scale = elementHeight / window.innerHeight 
  else scale = window.innerHeight / elementHeight

  return scale
}


export const scaleFactorFitWidth = (w, h, ew, eh) => {
  let scale = 1
  scale = scaleFactor(h, eh)
  // if(scale < 1){
  //   if(h > w && w > scale * ew) scale = scaleFactor(w, ew)  
  // }
  // else{
  //   if(h > w && w < scale * ew) scale = scaleFactor(w, ew)
  // }
  if(h > w && w > scale * ew) scale = scaleFactor(w, ew)  
  return scale
}
export const scaleFactor = (gameScreen, elementWidth) => gameScreen / elementWidth

export const minScaleFactor = (width, height) => Math.min(window.innerWidth / width , window.innerHeight / height)
